import React from 'react';
import '../css/HomePage.css';
import { Button } from 'flowbite-react';

const HomeHeader = ({ handleClickLogin}) => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-[94%] flex justify-between py-5">
        <img src={"logo192.png"} alt="Logo" className="h-[3rem] w-[3rem]" />
        <div className="flex gap-5">
          <Button
             className="border-2 border-blue-500 text-blue-500 bg-transparent hover:bg-blue-500 hover:text-white text-label transition-all duration-300 ease-in-out"
            onClick={handleClickLogin}
          >
            Log in
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HomeHeader;
